import { lazy } from "react";

export const InternalChatPage = lazy(() =>
  import("./features/internal-chat").then((module) => ({
    default: module.InternalChatPage,
  })),
);
